<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.33333 4.66663L4 7.99996L7.33333 11.3333" stroke="#2F2B3D" stroke-opacity="0.4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.3333 4.66663L8 7.99996L11.3333 11.3333" stroke="#2F2B3D" stroke-opacity="0.4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>